import React from "react";
import Table from "../Table";
import { Card, CardBody } from "reactstrap";
const dayjs = require('dayjs')

const Docs = ({ data, columns, customButton, ...props }) => {

    return (
        <Card className="myCard">
            <CardBody>
                <Table
                    headerClass="title-custom-value"
                    columns={columns}
                    data={data}
                    itemsByPage={10}
                    options={{
                        large: false,
                        downloads: {
                            pdf: false,
                            xlsx: true,
                        },
                        pagination: true,
                        search: true,
                    }}
                    customAdd={props.children}
                    nameXlsx={`Documents-${dayjs().format('YYYYMMDD')}.xlsx`}
                />
            </CardBody>
        </Card>
    )
}


Docs.defaultProps = {
    columns: [],
    data: []
};

export default Docs;